import { v4 as uuidv4 } from 'uuid';

export function getNewRowID() {
  return `row_${uuidv4()}`;
}
